module.exports = __webpack_public_path__ + "static/media/Merriweather-Light.9341552d.ttf";